import React from "react";
import { FileTypeKey } from "../../logics/enums/FileTypeKey";
import {PdfViewer} from "../../../PdfViewer/PdfViewer";
import {t} from "@lingui/macro";
import NoPreviewIframe from "../../../../containers/Page/NoPreviewIframe";
import {Styled} from "./Style";

export function LightboxContentInner({ fileLightboxProps }) {
    if (fileLightboxProps.hasError)
        return <Styled>{t`Failed to load. Please try again.`}</Styled>;

    // eslint-disable-next-line no-underscore-dangle
    if (fileLightboxProps._showLazyLoading)
        return <img src="/img/loading.gif" alt={t`Loading...`} />;

    switch (fileLightboxProps.lightboxFileType) {
        case FileTypeKey.IMAGE:
            return <img src={fileLightboxProps.src} alt={fileLightboxProps.alt} />;
        case FileTypeKey.PDF:
            return <PdfViewer pdfUrl={fileLightboxProps.src} alt={fileLightboxProps.alt} />;
        case FileTypeKey.UNSUPPORTED:
        default:
            return <NoPreviewIframe alt={fileLightboxProps.alt} src={fileLightboxProps.src} />;
    }
}
